import gsap from 'gsap';

export default function initContinueReading() {
    const modal = document.querySelector('.continue-modal');
    const openBtn = document.querySelector('.continueReadingBtn');
    if (!modal || !openBtn) return;

    const backdrop = modal.querySelector('.continue-modal__backdrop');
    const content = modal.querySelector('.continue-modal__content');
    const closeBtn = modal.querySelector('.continue-modal__close');

    const getPageWrapper = () => (
        document.querySelector('[data-barba="container"] .page-wrapper') ||
        document.querySelector('.page-wrapper')
    );

    function openModal() {
        modal.style.display = 'block';
        document.body.classList.add('body--modal-open');
        try { window.lenis?.stop(); } catch (_) { }

        const pw = getPageWrapper();
        gsap.killTweensOf([backdrop, content, pw].filter(Boolean));

        gsap.set(content, {
            position: 'absolute',
            left: 0,
            top: '3vh',
            width: '100%',
            height: '97vh',
            opacity: 1,
            y: '100vh',
            willChange: 'transform'
        });

        const ease = (gsap.parseEase && gsap.parseEase('custom')) || 'power3.inOut';

        requestAnimationFrame(() => {
            const tl = gsap.timeline({ defaults: { ease } });
            tl.to(backdrop, { opacity: 1, duration: 0.18 }, 0);

            const pw3 = getPageWrapper();
            if (pw3) {
                tl.set(pw3, { transformOrigin: 'top' }, 0);
                tl.to(pw3, { scale: 0.9, duration: 0.5 }, 0);
            }

            tl.to('.header', { y: '3vh', duration: 0.5 }, 0);
            tl.to(content, { y: 0, duration: 0.5 }, 0);
        });
    }

    function closeModal() {
        const pw = getPageWrapper();
        gsap.killTweensOf([backdrop, content, pw].filter(Boolean));

        const ease = (gsap.parseEase && gsap.parseEase('custom')) || 'power3.inOut';
        const tl = gsap.timeline({
            defaults: { ease },
            onComplete: () => {
                modal.style.display = 'none';
                document.body.classList.remove('body--modal-open');
                try { window.lenis?.start(); } catch (_) { }
                gsap.set(content, { clearProps: 'all' });
                const pw5 = getPageWrapper();
                if (pw5) gsap.set(pw5, { clearProps: 'transform,scale' });
            }
        });

        tl.to(content, { y: '100vh', duration: 0.65 }, 0);
        const pw6 = getPageWrapper();
        if (pw6) tl.to(pw6, { scale: 1, duration: 0.65 }, 0);
        tl.to('.header', { y: 0, duration: 0.65 }, 0);
        tl.to(backdrop, { opacity: 0, duration: 0.2 }, 0.45);
    }

    openBtn.addEventListener('click', openModal);
    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.style.display === 'block') {
            closeModal();
        }
    });
}
